import {api} from '../../api';
import {createMutation} from '../../lib';

const {getDocumentsDocIdContent} = api.documents;

export const useDeleteContractsCidDocumentId = createMutation((params: Parameters<typeof getDocumentsDocIdContent>) =>
  getDocumentsDocIdContent(...params),
);
